import styles from './closeform.module.css'

const CloseForm = ({onclick}) => {
    return(
        <div onClick={onclick} className={styles.closeForm}></div>
    )
}

export default CloseForm